import React from "react";
import { Box, Grid } from "@material-ui/core";
import ListEkloksContainer from "../../containers/ekloks/ListEkloksContainer";
import ListPlantsContainer from "../../containers/plants/ListPlantsContainer";
import PlantCard from "./PlantCard";
import EklokCard from "./EklokCard";

const AdminView = () => {
  return (
    <Box p={3} mb="5%">
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <ListPlantsContainer>
            {({ content, onViewAllAction }) => (
              <PlantCard plants={content} action={onViewAllAction} />
            )}
          </ListPlantsContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ListEkloksContainer>
            {({ content, onViewAllAction, updateStatus }) => (
              <EklokCard
                ekloks={content}
                action={onViewAllAction}
                updateStatus={updateStatus}
              />
            )}
          </ListEkloksContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminView;
